import React from 'react';
var defaultProps = {
  specialInstructions: ''
};
function HeaderActions(_ref) {
  var specialInstructions = _ref.specialInstructions;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, "Special Instructions"), /*#__PURE__*/React.createElement("p", null, specialInstructions));
}
HeaderActions.defaultProps = defaultProps;
export default HeaderActions;